import React from "react";
import Loader from "react-loader-spinner";
import './apartment-view.css';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

const ApartmentView = (props) => {
    if(!props.apartment){
        return <Loader type="Bars" color="#20c453" height={50} width={50}
                        visible={true}/>
    }
    const img = props.apartment.images_url.map(m =>
        <img src={m} alt=""/>
    )
    return(
        <>
            <section className="listings-content-wrapper section-padding-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-xs-8">
                            <div className="single-listings-sliders owl-carousel">
                                <AliceCarousel
                                    items={img}
                                    autoPlayInterval={2000}
                                    autoPlayDirection="rtl"
                                    autoPlay={true}
                                    fadeOutAnimation={true}
                                    mouseTrackingEnabled={true}
                                    disableAutoPlayOnAction={true}/>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="listings-content">
                                <div className="list-price">
                                    <p>${props.apartment.price_per_month}</p>
                                </div>
                                <h5>{props.apartment.title}</h5>
                                <p className="fa fa-map-marker location"> {props.apartment.address.country},
                                    {props.apartment.address.city}</p>
                                <p>{props.apartment.description}</p>
                                <div className="property-meta-data d-flex align-items-end">
                                    <div className="new-tag">
                                        <img src="img/icons/new.png" alt=""/>
                                    </div>
                                    <div className="bathroom">
                                        <img src="img/icons/bathtub.png" alt=""/>
                                            <span>2</span>
                                    </div>
                                    <div className="garage">
                                        <img src="img/icons/garage.png" alt=""/>
                                            <span>2</span>
                                    </div>
                                    <div className="space">
                                        <img src="img/icons/space.png" alt=""/>
                                            <span>120 sq ft</span>
                                    </div>
                                </div>

                                <ul className="listings-core-features d-flex align-items-center">
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Gated Community</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Automatic Sprinklers</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Fireplace</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Window Shutters</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Ocean Views</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Heated Floors</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Heated Floors</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Private Patio</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Window Shutters</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Fireplace</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Beach Access</li>
                                    <li><i className="fa fa-check" aria-hidden="true"></i> Rooftop Terrace</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-10 col-xs-10">
                            <div className="contact-realtor-wrapper">
                                <div className="realtor-info">
                                    <img src={props.apartment.owner_apartment.avatar} alt=""/>
                                        <div className="realtor---info">
                                            <h2>Jeremy Scott</h2>
                                            <p>Realtor</p>
                                            <h6><img src="img/icons/phone-call.png" alt=""/> +45 677 8993000 223</h6>
                                            <h6><img src="img/icons/envelope.png" alt=""/> office@template.com</h6>
                                        </div>
                                        <div className="realtor--contact-form">
                                            <form action="#" method="post">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" id="realtor-name"
                                                           placeholder="Your Name"/>
                                                </div>
                                                <div className="form-group">
                                                    <input type="number" className="form-control" id="realtor-number"
                                                           placeholder="Your Number"/>
                                                </div>
                                                <div className="form-group">
                                                    <input type="enumber" className="form-control" id="realtor-email"
                                                           placeholder="Your Mail"/>
                                                </div>
                                                <div className="form-group">
                                                    <textarea name="message" className="form-control"
                                                              id="realtor-message" cols="30" rows="10"
                                                              placeholder="Your Message"></textarea>
                                                </div>
                                                <button type="submit" className="btn south-btn">Send Message</button>
                                            </form>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid col-lg-12 col-sm-10 col-xs-10">
                            <div className="map-responsive">
                                <iframe
                                    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&q=Eiffel+Tower+Paris+France"></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid col-12">
                    </div>
                </div>
            </section>
            </>
    )
};
export default ApartmentView;